import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { TValidSdcColumns } from './../../sdc-columns.type';
import { SdcStateServiceBaseModel } from './../sdc-state-basemodel';
// import { DEFAULT_SORT } from './../default-sort.constant';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class CreditGapsConfigService extends SdcStateServiceBaseModel implements ISdcActivity {
  static $inject = ['ImSchool'];

  constructor(private ImSchool: ImSchool) {
    super();
  }

  get humanName() {
    return sdcStateConfigConstant.CREDIT_GAPS.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.CREDIT_GAPS.state;
  }

  get columns(): TValidSdcColumns[] {
    const fullColumns = [
      'studentId',
      'studentName',
      'cohort',
      'seniorFlag',
      'isSuperSenior',
      'status',
      'admitDate',
      'dischargeCode',
      'dischargeDate',
      'creditGapPriorityGrouping',
      'grade',
      'officialClass',

      // google classroom
      'classroomRemoteEngagementLast5',
      'classroomRemoteEngagement',
      'classroomTotalAssignments',
      'classroomTotalEngagedAssignments',
      'classroomTotalEnrolled',
      'classroomStudentEmail',

      'atsCounselor',
      'advisor',
      'iep',
      'ell',
      'homeLanguage',
      'attendanceYtd',
      'plannedGraduationDate',
      'gradPlan',
      'currentCourses',
      'currentCourseCodes',
      'totalCreditsEarned',
      'subjectsWithCreditGaps',
      'creditMaxGaps',
      'creditMaxGapsNoPlan',
      'coursesPotentiallyEligibleForCreditRecovery',
      'coursesPotentialCreditIssues',
      'countOfCreditGapPendingChanges',
      'pendingCourseAdditions',
      'pendingCourseAdditionsWithoutSection',
      'pendingCourseDrops',
      'gapPlansSummary',
      'hasPotentialCreditIssuesOnCurrProgram',
      'hasPotentialCreditIssuesOnTranscript',
      'hasGapPlansPastPlannedGradDate',
      'countOfRegentsPassedForDiploma',
      'countOfRegentsPassedForGrad',
      'countOfRegentsPassedAt65Of5',
      'countOfRegentsPassedAt55Of5SpedOnly',
      'countOfRegentsPassedAt65Of9',
      'creditGapsStartTotal',
      'creditGapsTotal',
      'creditGapsStartElaCore',
      'creditGapsElaCore',
      'creditGapsStartMath',
      'creditGapsMath',
      'creditGapsStartSsGlobal',
      'creditGapsSsGlobal',
      'creditGapsStartSsUs',
      'creditGapsSsUs',
      'creditGapsStartSsGovtEcon',
      'creditGapsSsGovtEcon',
      'creditGapsStartSciTotal',
      'creditGapsSciTotal',
      'creditGapsStartSciPhysical',
      'creditGapsSciPhysical',
      'creditGapsStartSciLife',
      'creditGapsSciLife',
      'creditGapsStartLote',
      'creditGapsLote',
      'creditGapsStartCte',
      'creditGapsCte',
      'creditGapsStartArt',
      'creditGapsArt',
      'creditGapsStartPe',
      'creditGapsPe',
      'creditGapsStartHealth',
      'creditGapsHealth',

      // added for community schools on 3/22
      'schoolPriorityFlag',
    ];

    // based on toggle return either or
    return fullColumns as TValidSdcColumns[];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return ['isSuperSenior'];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    const school = this.getSchool();

    const filter: IFilter = {
      status: ['A'],
    };

    // Transfer schools should not be filtered by cohort
    const isTransfer = this.ImSchool.isTransferSchool(school);
    if (isTransfer) return filter;

    const seniorAndSuperCohorts = this.ImSchool.getSeniorAndSuperCohorts(school);

    let mostSeniorCohort;
    if (seniorAndSuperCohorts.length === 0) {
      mostSeniorCohort = _.min(school.uniqueCohorts);
    }

    // Otherwise return either senior + super senior cohorts, or the single most senior cohort
    const cohort = _.size(seniorAndSuperCohorts) ? seniorAndSuperCohorts : [mostSeniorCohort];

    filter.cohort = cohort;

    return filter;
  }

  get sort(): IColumnSort[] {
    return [
      {
        colId: 'creditMaxGapsNoPlan',
        sort: 'desc',
      },
    ];
  }

  get bundleName() {
    return 'CREDIT_GAPS';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.CREDIT_GAPS.availableSdcViews;
  }
}
